import EmojiPicker from "./EmojiPicker.vue";
import EmojiPickerDialog from "./EmojiPickerDialog.vue";

export declare type EmojiPickerRequest = {
	picker: typeof EmojiPicker;
	buttonEl: HTMLElement;
	initialValue: string;
	callbacks: EmojiDialogCallbacks;
};

export declare type EmojiDialogCallbacks = {
	valueUpdated: (newValue: string) => void,
	closed: () => void,
	opened: () => void
};

class EmojiHandler {
	dialog: typeof EmojiPickerDialog | null = null;
	activePicker: EmojiPickerRequest | null = null;

	registerDialog(instance: typeof EmojiPickerDialog): void {
		if (this.dialog !== null) {
			console.warn("Emoji dialog already registered!");
			return;
		}

		this.dialog = instance;
	}

	unregisterDialog(instance: typeof EmojiPickerDialog): void {
		if (instance !== this.dialog) {
			return;
		}

		this.clearActivePicker();
		this.dialog = null;
	}

	clearActivePicker(): void {
		if (this.dialog) {
			//@ts-ignore
			this.dialog.close();
		}

		this.activePicker = null;
	}

	activateForPicker(info: EmojiPickerRequest): void {
		if (this.dialog === null) {
			return;
		}

		this.activePicker = info;
		//@ts-ignore
		this.dialog.bindTo(info.buttonEl, info.initialValue, info.callbacks);
		//@ts-ignore
		this.dialog.open();
	}

	deactivateForPicker(picker: typeof EmojiPicker): void {
		if (this.activePicker === null || picker !== this.activePicker.picker) {
			return;
		}

		if (this.dialog) {
			//@ts-ignore
			this.dialog.unbind();
		}

		this.clearActivePicker();
	}

	dialogIsOpen(): boolean {
		if (this.dialog === null) return false;
		//@ts-ignore
		return this.dialog.dropdownOpen;
	}
}

const emojiHandler = new EmojiHandler();
export default emojiHandler;
